/**
 * @generated SignedSource<<ca4a8ae1fa048bbb0787f34068b1bae7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoryReaderFinishMutation$variables = {
  bookId: string;
};
export type StoryReaderFinishMutation$data = {
  readonly finishStory: {
    readonly read: {
      readonly book: {
        readonly finished: boolean;
        readonly id: string;
      };
      readonly finishedAt: any;
    };
  };
};
export type StoryReaderFinishMutation = {
  response: StoryReaderFinishMutation$data;
  variables: StoryReaderFinishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookId",
        "variableName": "bookId"
      }
    ],
    "concreteType": "FinishStoryPayload",
    "kind": "LinkedField",
    "name": "finishStory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoryRead",
        "kind": "LinkedField",
        "name": "read",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoryBook",
            "kind": "LinkedField",
            "name": "book",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryReaderFinishMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StoryReaderFinishMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "80672ef562c0e965722356dcde25a6a6",
    "id": null,
    "metadata": {},
    "name": "StoryReaderFinishMutation",
    "operationKind": "mutation",
    "text": "mutation StoryReaderFinishMutation(\n  $bookId: ID!\n) {\n  finishStory(bookId: $bookId) {\n    read {\n      finishedAt\n      book {\n        id\n        finished\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "40e995766624f0bc81b08b41a03f910b";

export default node;
